export { RatingComponent } from './rating.component';
export { RatingModule } from './rating.module';



// WEBPACK FOOTER //
// ./src/rating/index.ts